<template>
   <v-card class="mx-auto" :max-width="width" flat>
      <v-toolbar color="primary" dense flat>
         <v-toolbar-title class="white--text titulo-historial">
            HISTORIAL DE ESTADOS
         </v-toolbar-title>
         <v-spacer></v-spacer>
         <span v-if="carnet" class="white--text titulo-historial">
            {{ carnet }}
         </span>
      </v-toolbar>

      <div v-if="estados.length" class="lista">
         <div
            v-for="(item, index) in estados"
            :key="item.id"
            class="fila"
            :class="{ 'fila--par': index % 2 === 1 }"
         >
            <div class="d-flex align-center">
               <span class="estado">{{ item.estadoCaso }}</span>
               <v-spacer></v-spacer>
               <span class="fecha">{{ item.fecha }} · {{ item.hora }}</span>
            </div>
            <div class="usuario">{{ item.user || 'Sin registrar' }}</div>
         </div>
      </div>

      <div v-else class="text-center sin-historial">Sin historial</div>
   </v-card>
</template>

<script>
export default {
   props: {
      width: {
         type: Number,
         default: 500
      },
      estados: {
         type: Array,
         default: function () {
            return []
         }
      },
      // Carnet del alumno, para saber de quién es el historial que se está viendo
      carnet: {
         type: String,
         default: ''
      }
   },
   data: () => ({})
}
</script>

<style lang="scss" scoped>
.titulo-historial {
   font-size: 15px;
   font-weight: 600;
   letter-spacing: 0.5px;
}
/* Se limita el alto para que un historial largo no estire el diálogo
   fuera de la pantalla; a partir de ahí la lista se desplaza. */
.lista {
   max-height: 320px;
   overflow-y: auto;
}
.fila {
   padding: 8px 14px;
   border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.fila--par {
   background: rgba(0, 0, 0, 0.02);
}
.fila:last-child {
   border-bottom: none;
}
.estado {
   font-size: 15px;
   font-weight: 600;
   color: rgba(0, 0, 0, 0.85);
}
.fecha {
   font-size: 13px;
   color: rgba(0, 0, 0, 0.55);
   white-space: nowrap;
}
.usuario {
   font-size: 14px;
   color: var(--v-primary-base);
}
.sin-historial {
   color: rgba(0, 0, 0, 0.38);
   font-size: 15px;
   padding: 24px 0;
}
</style>
